// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__4c5q0","buttonWrapper":"Footer_buttonWrapper__sJj_9"};